import { create } from 'zustand';
import { persist } from 'zustand/middleware'

export const useDataGatewayPageStore = create()(
  persist(
    (set) => ({
      isListMode: true, // Indica si las cotizaciones deben mostrarse en formato lista
      setIsListMode: (value) => set({ isListMode: value }),
    }),
    {
      name: 'data-gateway-page',
    }
  ));